if (!customElements.get('yotpo-reviews')) {
  customElements.define(
    'yotpo-reviews',
    class YotpoReviews extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.debug = false;
        this.checkIfYotpoHorizontalPaginationLoaded();
      }

      checkIfYotpoHorizontalPaginationLoaded = () => {
        if (this.debug) console.log('checkIfYotpoHorizontalPaginationLoaded()');
        // Wait for the Yotpo script to load or for the widget to appear
        const checkInterval = setInterval(() => {
          const yotpoWidget = document.querySelector('.yotpo-horizontal-pagination'); // Replace with the actual selector
          if (yotpoWidget) {
            clearInterval(checkInterval);
            if (this.debug) console.log('Yotpo widget loaded');
            this.setupPaginationObserver();
          }
        }, 1000); // Check every second
      };

      // Function to set up the MutationObserver
      setupPaginationObserver() {
        if (this.debug) console.log('setupPaginationObserver()');
        const paginationContainer = document.querySelector('.yotpo-horizontal-pagination');

        // Attach listeners to initially loaded pagination elements
        const initialPaginationElements = paginationContainer.querySelectorAll(
          '.yotpo-horizontal-pagination .yotpo-reviews-pagination-item'
        ); // Adjust the selector as needed
        this.attachPaginationListeners(initialPaginationElements);

        // now we attach listeners to any new pagination elements that are added
        const observer = new MutationObserver((mutationsList) => {
          for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              // Find newly added pagination elements
              const newPaginationElements = mutation.addedNodes;
              newPaginationElements.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE && node.matches('.yotpo-reviews-pagination-item')) {
                  // Adjust the selector as needed
                  this.attachPaginationListeners([node]);
                }
              });
            }
          }
        });

        observer.observe(paginationContainer, { childList: true, subtree: true });
      }

      // Function to attach listeners to pagination elements
      attachPaginationListeners(paginationElements) {
        if (this.debug) console.log('attachPaginationListeners()');
        paginationElements.forEach((element) => {
          element.addEventListener('click', (event) => {
            // Handle the click event
            event.preventDefault();
            //            const offset_top = document.querySelector('.yotpo-widget-instance').getBoundingClientRect().top + window.scrollY - 100;
            this.disableParentScrollTo();
          });
        });
      }

      // Function to disable the Yotpo's native scrollTo function
      disableParentScrollTo() {
        if (this.debug) console.log('disableParentScrollTo()');
        const current_y_position = window.scrollY;
        window.scrollTo({
          top: current_y_position,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  );
}
